module.exports = __webpack_public_path__ + "static/media/invoicingar_cc_pay_guide_2.3038fed1.png";